export const seoCarCategoriesState = ({ data, component } = {}) => {
  if (!data) {
    return false;
  }

  return {
    data,
    component,
  };
};
